<template>
  <records></records>
</template>

<script>
export default {
  components: {
    records: () => import('@/modules/accounting/views/records.vue'),
  },
}
</script>